import { Box, Grid, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FC, ReactElement } from "react";
import { Heading3 } from "../typography";

const useStyles = makeStyles((theme: Theme) => ({
  cardWrapper: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 12,
    minWidth: 286,
    minHeight: 160,
    height: 160
  }
}));

export const KeyCard: FC<{
  unitName: string;
  labels: {
    unit: string;
    tag: string;
  };
  PropertyLogo?: ReactElement;
  KeyProvideLogo?: ReactElement;
}> = ({ unitName, labels, PropertyLogo, KeyProvideLogo }) => {
  const classes = useStyles();
  return (
    <Box className={classes.cardWrapper}>
      <Grid display="grid" container height="100%" direction="column">
        <Grid item p={2}>
          <Heading3 textAlign="right" color="common.white">{`${labels.unit} ${unitName}`}</Heading3>
        </Grid>
        <Grid item p={2} alignSelf="flex-end">
          <Grid container spacing={2} wrap="wrap">
            {PropertyLogo && (
              <Grid item sx={{ maxWidth: "50%" }}>
                {PropertyLogo}
              </Grid>
            )}
            {KeyProvideLogo && (
              <Grid item sx={{ maxWidth: "50%" }}>
                {KeyProvideLogo}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
